import { Alert, AlertTitle, styled } from "@mui/material";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

const PREFIX = 'DropoffAddressValidationMessage';

const classes = {
  message: `${PREFIX}-message`,
};

const StyledMessage = styled(Alert)(({ theme }) => ({
  maxWidth: 400,
  transition: 'all 0.2s ease-in-out',
}));

const DropoffAddressValidationMessage = ({ index }: { index: number }) => {
  const { t } = useTranslation('common');

  const displayInvalidF1DropoffAddress = false;
  const displayInvalidMemberPortalDropoffAddress = false;
  const displayInvalidClientPortalDropoffAddress = false;

  // TODO: Determine how to pull this from somewhere
  const clientContactName = 'Alignment Health Plan';
  const clientContactPhoneNumber = '(844) 445-2824';

  return (
    <>
      {/* F1 Address Validation */}
      {displayInvalidF1DropoffAddress && (
        <>
          <StyledMessage
            icon={<InfoOutlinedIcon color="warning" />}
            severity={'warning'}>
            <AlertTitle>
              <strong>
                {t('addressValidation.addressNotApprovedTitle')}
              </strong>
            </AlertTitle>
            {t('addressValidation.addressNotApprovedMessage')}
            <AlertTitle sx={{ fontSize: '14px', marginTop: '10px' }}>
              <strong>
                {t('addressValidation.addressNotApprovedSecondAttempt')}
              </strong>
            </AlertTitle>
            <Trans
              i18nKey="addressValidation.addressNotApprovedSecondAttemptMessage"
              values={{
                client_name: clientContactName,
                phone_number: clientContactPhoneNumber,
              }}
              components={{ strong: <strong /> }}
            />
          </StyledMessage>
        </>
      )}
      {/* Member Portal Address Validation */}
      {displayInvalidMemberPortalDropoffAddress && (
        <>
          <StyledMessage
            icon={<InfoOutlinedIcon color="warning" />}
            severity={'warning'}>
            <AlertTitle>
              <strong>
                {t('addressValidation.addressNotApprovedTitle')}
              </strong>
            </AlertTitle>
            <Trans
              i18nKey="addressValidation.addressNeedsApprovedLocationMessage"
              values={{
                client_name: clientContactName,
                phone_number: clientContactPhoneNumber,
              }}
              components={{ strong: <strong /> }}
            />
          </StyledMessage>
        </>
      )}

      {/* Client Portal Address Validation */}
      {displayInvalidClientPortalDropoffAddress && (
        <>
          <StyledMessage
            icon={<InfoOutlinedIcon color="warning" />}
            severity={'warning'}>
            <AlertTitle>
              <strong>
                {t('addressValidation.addressLowConfidenceTitle')}
              </strong>
            </AlertTitle>
            {t('addressValidation.addressLowConfidenceMessage')}
          </StyledMessage>
        </>
      )}
    </>
  );
};

export { DropoffAddressValidationMessage };
